import { render, staticRenderFns } from "./StatsOverlay.vue?vue&type=template&id=6683aa5a&scoped=true"
import script from "./StatsOverlay.vue?vue&type=script&lang=js"
export * from "./StatsOverlay.vue?vue&type=script&lang=js"
import style0 from "./StatsOverlay.vue?vue&type=style&index=0&id=6683aa5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683aa5a",
  null
  
)

export default component.exports